export default "__VITE_ASSET__C3E0pXIr__"